module.exports = __webpack_public_path__ + "static/media/DeleteButton_72dpi.255a001f.png";